export enum Actions {
    ADD_SLOTS = "ADD_SLOTS",
    SET_MODELS = "SET_MODELS",
    SELECT_SLOT = "SELECT_SLOT",
    MOVE_MODEL = "MOVE_MODEL",
    UPDATE_SLOT = "UPDATE_SLOT",
    UPDATE_MODEL = "UPDATE_MODEL",
    DELETE_MODEL = "DELETE_MODEL",
    ADD_MODEL = "ADD_MODEL",
    UPDATE_MODELS = "UPDATE_MODELS",
    DELETE_MODELS = "DELETE_MODELS",
    SET_MODEL = "SET_MODEL"
}


export enum ViewState {
    Home,
    FightMenu,
    LiveBattle,
    TroopSelection,
    WatchLiveBattle,
    WatchBattleReplay,
    ReadyModal
}

export enum SignalREvent {
    ReceiveMessage = "ReceiveMessage",
    BattleUpdate = "BattleUpdate",
    ReadyCheck = "ReadyCheck",
    StartFormation = "StartFormation",
    StartBattle = "StartBattle",
    Pong = "Pong",
    BattleList = "BattleList",
    NewBattle = "NewBattle",
    EndBattle = "EndBattle",
    SignIn = "SignIn",
    Close = "close",
    HostCreated = "HostCreated",
    Reconnecting = "reconnecting",
    Reconnected = "reconnected"
}
export enum BattleUpdateType {
    Message = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
    Chat = 4,
    TroopAction = 5,
    EndBattle = 6,
    FindMatch = 7,
    FindMatchCanceled = 8,
    ReadyCheckCanceled = 9,
    FormationCanceled = 10,
    AFKTimeout = 11,
    BattleTimeout = 12,
}
export enum ArenaBattleStateEnum {
    Free = 1, // Default State: Player does not pressed find match button yet
    FindingMatch = 2, // Player pressed Find Match button but not found any match yet
    HostingMatch = 3, // Player is hosting a match but no one joined yet
    ReadyCheck = 4, // Ready Check State
    ReadyCheckSubmitted = 5, // Player submitted Ready Check but other player(s) not submitted yet
    Formation = 6, // Formation Page State
    FormationSubmitted = 7, // Player submitted Formation but other player(s) not submitted yet
    InBattle = 8 // Player is in live battle
}
export enum ConnectionStatus {
    Disconnected = "Disconnected",
    Connecting = "Connecting",
    Connected = "Connected"
}

export enum TroopActions {
    Enter = 1,
    Move = 2,
    Attack = 3,
    Heal = 4,
}

export enum MessagesVariant {
    Success = "success",
    Error = "error",
    Normal = "normal",
}
export enum TroopAttribute {
    Health = 0,
    Armor = 1,
    Healing = 3,
    MagicResistance = 4,
    Damage = 5,
    Range = 6,
    Buffs = 7
}

export enum SignalRAction {
    SendMessage = "SendMessage",
    FindMatch = "FindMatch",
    HostMatch = "HostMatch",
    JoinMatch = "JoinMatch",
    SubmitFormation = "SubmitFormation",
    submitFormationAndWait = "submitFormationAndWait",
    SubmitMyArmy = "SubmitMyArmy",
    SubmitMyArmyAndWait = "SubmitMyArmyAndWait",
    Ready = "Ready",
    NotReady = "NotReady",
    SubscribeToBattleList = "SubscribeToBattleList",
    UnsubscribeFromBattleList = "UnsubscribeFromBattleList",
    WatchBattle = "WatchBattle",
    Surrender = "Surrender",
    Ping = "Ping",
    Action = "Action"
}


export enum MoveTroopType {
    BARRACKS = "barracks",
    CAMP = "arena"
}

export enum AdventureMode {
    Solo = 1,
    PrivateRaid = 2,
    GuildRaid = 3,
    PublicRaid = 4,
    ArenaFriendlyMatch = 9,
    ArenaFree100kNoEnergy = 10,
    ArenaFree100k = 11,
    ArenaFree300k = 12,
    ArenaFree900k = 13,
    ArenaFree2700k = 14,
    ArenaFree8100k = 15,
    Arena100k = 21,
    Arena300k = 22,
    Arena900k = 23,
    Arena2700k = 24,
    Arena8100k = 25,
}

export enum AdventureResultEnum {
    Win = 1,
    Lose
}